"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeader = exports.exitCallback = exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../../util/ServiceRegistry"));
var _dcCore = require("dc-core");
var _AppUtil = require("../../util/AppUtil");
var _Events = _interopRequireDefault(require("../../constants/Events"));
var _AppConstants = _interopRequireDefault(require("../../constants/AppConstants"));
var _EditUtil = _interopRequireDefault(require("../../util/EditUtil"));
var _CallbackTypes = _interopRequireWildcard(require("../../constants/CallbackTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const callDropinMethod = (dropinId, methodName, opts) => _dcCore.discovery.callBootstrapMethod(dropinId, methodName, opts);
const exitCallback = async () => {
  const appStore = _ServiceRegistry.default.getService("AppStore");
  appStore.setDropinName("preview");
  await callDropinMethod("verb-edit-pdf-viewer", "exitCallback", {
    context: _AppConstants.default.CONTEXT,
    selectionName: _AppConstants.default.SELECTION_NAME
  }).then(() => {
    (0, _EditUtil.default)(_CallbackTypes.EditEventTypes.CLOSE_EDIT, _CallbackTypes.default.EDIT_EVENT_HANDLER);
  }, err => {
    appStore.setDropinName("edit");
    (void 0).loggingService.error("exit callback error is", err);
  });
};
exports.exitCallback = exitCallback;
const getHeader = async () => {
  const appStore = _ServiceRegistry.default.getService("AppStore");
  appStore.setDropinName("preview");
  return callDropinMethod("verb-edit-pdf-viewer", "getLabel", {
    context: _AppConstants.default.CONTEXT,
    selectionName: _AppConstants.default.SELECTION_NAME
  });
};
exports.getHeader = getHeader;
class DropinService {
  constructor() {
    this.initialize = () => {
      this._appstore = _ServiceRegistry.default.getService("AppStore");
      this.loggingService = _ServiceRegistry.default.getService("LoggingService");
      this.toolsBoardService = _ServiceRegistry.default.getService("ToolsBoardService");
      this.initializeHelper();
    };
    this.initializeHelper = () => {
      const loadDelay = 20;
      if (!this._appstore.isInPreview) {
        this.loadBootstraps();
      } else {
        setTimeout(() => {
          this.loadBootstraps();
        }, loadDelay);
      }
    };
    this.loadBootstraps = () => {
      if (!this.loadBootstrapPromise) {
        this.loadBootstrapPromise = new Promise(resolve => {
          const bootstrapPromises = [];
          const dropinList = this._appstore.configStore.getConfig().toolsDropinList.slice();
          dropinList.forEach(dropins => {
            dropins.forEach(name => {
              if (name === _AppConstants.default.EDIT_WORKFLOW.DROPIN) {
                this.initDropin(name);
              }
              if (!this._appstore.bootstraps[name]) {
                const bootstrapPromise = _dcCore.discovery.loadDropin((0, _AppUtil.getMappedDropinName)(name));
                bootstrapPromises.push(bootstrapPromise);
                bootstrapPromise.then(bootstrapObj => {
                  const {
                    bootstrap
                  } = bootstrapObj;
                  // Replace map each time because PureComponent does
                  // shallow compare.
                  const bootstraps = _objectSpread({}, this._appstore.bootstraps);
                  bootstraps[name] = bootstrap;
                  this._appstore.setBootstraps(bootstraps);
                }, err => {
                  this.loggingService.error(err.stack || err.message);
                });
              }
            });
          });
          Promise.all(bootstrapPromises).then(() => {
            resolve();
          }).catch(() => resolve());
        });
      }
      return this.loadBootstrapPromise;
    };
    this.initDropin = dropinName => {
      _dcCore.discovery.callBootstrapMethod((0, _AppUtil.getMappedDropinName)(dropinName), "initializeAction", {
        context: _AppConstants.default.CONTEXT,
        preserveSelection: true,
        showCallback: () => {},
        enableCallback: () => {},
        selectionName: _AppConstants.default.SELECTION_NAME
      });
    };
    this.openDropin = async dropinName => {
      if (this._appstore.shouldLoadToolsBoardDropin) {
        await this.toolsBoardService.openToolsBoard();
      }
      this.loadBootstraps().then(() => {
        this._appstore.setDropinName(dropinName);
        this.dropinExecuteAction();
      });
    };
    this._appstore = _ServiceRegistry.default.getService("AppStore");
    this._appstore.getAppRenderingStartedPromise().then(() => this.initialize());
  }
  executeDropin(dropinName) {
    if (this._appstore.isAppReady) {
      this.openDropin(dropinName);
    }
    _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.default.APP_RENDERING_DONE, () => this.openDropin(dropinName));
  }
  dropinExecuteAction() {
    callDropinMethod((0, _AppUtil.getMappedDropinName)(this._appstore.dropinName), "executeAction", this._appstore.executeActionOpts).then(resp => {
      this._appstore.executeDropinPromise.resolve(resp);
    }, err => {
      this._appstore.executeDropinPromise.reject(err);
    });
  }
}
exports.default = DropinService;